export default "__VITE_ASSET__BYtXI9zD__"